import { extendTheme } from '@chakra-ui/react';
import 'focus-visible/dist/focus-visible';
import Button from './components/button';
import Checkbox from './components/checkbox';
import Tag from './components/tag';
import colors from './foundations/colors';
import styles from './styles';
export const theme = extendTheme({
    colors,
    styles,
    components: {
        Button,
        Checkbox,
        Tag,
    },
});
//# sourceMappingURL=index.js.map